import type { DeliveryState } from '../lib/engine.js';

/**
 * Галочки состояния доставки.
 *
 * Часы — сообщение ещё в очереди и до сервера не дошло;
 * одна галочка — сервер принял;
 * две — дошло до устройств собеседников;
 * две выделенные — прочитано.
 *
 * Рисуем как SVG, а не символами: «✓✓» в разных шрифтах выглядит по-разному
 * и на части систем расползается по ширине.
 */
export function Ticks({ state }: { state: DeliveryState }) {
  if (state === 'pending') {
    return (
      <svg class="ticks" viewBox="0 0 16 16" width="16" height="16" aria-label="отправляется">
        <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" stroke-width="1.5" />
        <path d="M8 4.5V8l2.5 1.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
      </svg>
    );
  }

  const read = state === 'read';
  const double = state === 'delivered' || read;

  return (
    <svg
      class={`ticks ${read ? 'read' : ''}`}
      viewBox="0 0 20 16"
      width="20"
      height="16"
      aria-label={read ? 'прочитано' : double ? 'доставлено' : 'отправлено'}
    >
      <path
        d="M2 8.5L5.5 12L12 4.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      {double && (
        <path
          d="M8.5 11.5L9.5 12.5L18 3"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      )}
    </svg>
  );
}
